import { memo, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { FaEdit } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import CustomModal from "../../../../app/common-components/CustomModal.jsx";
import { setCmdbId } from "../cmdb-overview/CMDBSlice.js";
import { getGoLive, saveGoLive, setAlertError } from './GoLiveSlice.js';
// import AlertBox from "../../../../app/common-components/"
import Input from "../../../../app/common-components/form/input.jsx";
import MonthPicker from "../../../../app/common-components/MonthYearPicker/Monthpicker.jsx";
import Spinner from "../../../../app/common-components/Spinner.jsx";
import { useCommonAlert } from "../../../../app/utilities/helpers.js";
import "../styles.scss";


const GoLiveAlertConfigutation = () => {
    const { state: Id } = useLocation();
    const dispatch = useDispatch();
    const rowId = Id?.id;
    console.log("rowId ==> ", rowId);

    dispatch(setCmdbId(rowId));
    const { callCommonAlert, hideCommonAlert } = useCommonAlert();
    const { error, liveGOGetData, liveGOGetLoading, liveGOSaveLoading } = useSelector(
        (state) => state.GoLiveApi
    );  
    const [state, setState] = useState({
        modalOpen: false,
        alert: false,
        alertType: "",
        alertMessage: "",
        formData: {
            "goLiveDate": "",
            "threshold": 80,
        },
        "thresholdError": false,
        "thresholdErrorMessage": "",
    });
    const [getGoLiveDate, setGoLiveDate] = useState();
    const [getThreshold, setThreshold] = useState();
    const callAlert = (type, msg) => {
        setState((state) => ({
            ...state,
            alert: true,
            alertType: type,
            alertMessage: msg
        }));
    };
    const hideAlert = () => {
        setTimeout(() => {
            setState((state) => ({
                ...state,
                alert: false,
                alertType: "",
                alertMessage:
                    "",
            }));
        }, 4000);
    };
    function allowNumericOnly(e) {
        const code = "charCode" in e ? e.charCode : e.keyCode;
        if (!(code >= 48 && code <= 57)) {
          e.preventDefault();
        }
      }
    const handleDateChange = (newValues) => {
        setState((prevState) => ({
        ...prevState,
        formData: {
            ...prevState.formData,
            "goLiveDate": newValues,
        },
        }));
    };
    const validateDateFormat = (input) => {
        const regex = /^(0?[1-9]|1[0-2])\/\d{4}$/;
        return regex.test(input);
    };
    const formatDateString = (dateString) => {
        if(dateString && validateDateFormat(dateString)){
            const [month, year] = dateString.split('/');
            const formattedMonth = month.padStart(2, '0'); 
            return `${formattedMonth}/${year}`;
        }
    };
    const currentDate = new Date();
const currentMonthYear = `${String(currentDate.getMonth() + 1).padStart(2, '0')}/${currentDate.getFullYear()}`;
    const modalBody = () => (
        <>
            <h3 className="editUserAcessReviewer marginAlign">Edit Go Live & Alert Configuration</h3>
            <>
                {liveGOSaveLoading ? (
                    <Spinner />
                ) : (
                    <>
                        <Row className="m-0">
                            <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                                <div className="mb-3">
                                    <MonthPicker
                                        onChange={handleDateChange}
                                        label={"Go Live Date"}
                                        format={"MM/YYYY"}
                                        value={state.formData.goLiveDate}
                                        minDate={currentMonthYear}
                                    />
                                </div>
                            </Col>
                            <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                                <div className="mb-3">
                                    <Input
                                        label={"Threshold %*"}
                                        type='text'
                                        list="serverlistdatalist"
                                        name={"threshold"}
                                        id="threshold"
                                        value={state.formData.threshold}
                                        className="form-control"
                                        placeholder="Enter Threshold in Percentage"
                                        error={state["thresholdError"]}
                                        errorMessage={state["thresholdErrorMessage"]}
                                        maxLength={2}
                                        containerClassName={"frmgroup validate default-input col-12 p-0"}
                                        onKeyPress={(e) => allowNumericOnly(e)}
                                        onChange={(e) => {
                                            handleOnChange('threshold', e.target.value);
                                        }}
                                    />
                                </div>
                            </Col>
                        </Row>
                        <div
                            className="server-btn"
                            style={{ display: "block", justifyContent: "end" }}
                        >
                            <button className="cancelBtnStyle btn btn-primary"
                                onClick={() => handleClose()}>Cancel</button>
                            <button className="btnStyle btn btn-primary"
                                onClick={() => {
                                    handleSaveReview();
                                }}>Save</button>
                        </div>
                    </>
                )}

            </>
        </>
    );
    const handleShow = () => {
        setState({
            ...state,
            modalOpen: true,
            "thresholdError": false,
            "thresholdErrorMessage": "",
            formData: {
                "goLiveDate": liveGOGetData.goLiveDate ? liveGOGetData.goLiveDate : "",
                "threshold": liveGOGetData.threshold ? liveGOGetData.threshold : 80,
            },
        });
    };
    const handleClose = () => {
        setState({
            ...state,
            modalOpen: false,
        });
        hideCommonAlert(10);
    };
    const handleOnChange = (name, selectedValue) => {
        if (state[`${name}Error`]) {
            setState((state) => ({
                ...state,
                [`${name}Error`]: false,
                [`${name}ErrorMessage`]: "",
            }));
        }
        if(name==="threshold"){
            if (selectedValue < 50 || selectedValue > 80) {
                callCommonAlert("warning", "Threshold Percentage should be between 50 to 80.");
            }else{
                hideCommonAlert(10);
            }
        }
        
        setState((state) => ({
            ...state,
            formData: {
                ...state.formData,
                [name]: selectedValue,
            },
            //   conformationPop:selectedValue === ""  ?false :true, 
        }));
    };
    const validateForm = () => {
        let formValidation = true;
        if (state.formData.threshold === "") {
            setState((state) => ({
                ...state,
                [`thresholdError`]: true,
                [`thresholdErrorMessage`]: `Field should not be empty`,
            }));
            hideCommonAlert(10);
            formValidation = false;
        } else if (state.formData.threshold < 50 || state.formData.threshold > 80) {
           
            formValidation = false;
        }
        return formValidation;
    };
    const handleSaveReview = () => {
        const validation = validateForm();
        if (validation) {
            const payload = {
                "id": 1,
                "goLiveDate": state.formData.goLiveDate ? state.formData.goLiveDate : "",
                "threshold": state.formData.threshold ? Number(state.formData.threshold) : 80
            };
            dispatch(saveGoLive({ payload, cmdbId: rowId })).then((data) => {
                if (data.payload?.statusCodeValue === 200) {
                    handleClose();
                    callCommonAlert("success", data.payload?.body);
                    getDatails();
                    hideCommonAlert();
                } else if (data.payload?.statusCodeValue === 400) {
                    callCommonAlert("error", data.payload?.body);
                    hideCommonAlert();
                }
            });
        }

    };
    useEffect(() => {
        if (error) {
            callCommonAlert("error", "Something went wrong. Please try again.");
            hideCommonAlert();
            dispatch(setAlertError());
        }
    }, [error]);
    const getDatails = () => {
        dispatch(getGoLive(rowId));
    };
    useEffect(() => {
        getDatails();
    }, []);
    useEffect(() => {
        setGoLiveDate(liveGOGetData.goLiveDate ? liveGOGetData.goLiveDate : "-");
        setThreshold(liveGOGetData.threshold ? liveGOGetData.threshold : 80);
    }, [liveGOGetData]);


    return (
        <>

            <div className="dashcol bg-white mt-3">
            <h4>Go Live & Alert Configuration
    <button className="solid-btn mx-2 float-right " onClick={handleShow}>
        Edit<FaEdit className="cmdbImgIcon mx-1" />
    </button>
</h4>
                <Row className="m-0">
                    <Col className="px-0">
                        <label className="d-flex"><span>Go Live Date : </span>
                            <span className="mx-2">{getGoLiveDate!=="-"?formatDateString(getGoLiveDate)?formatDateString(getGoLiveDate):"-":"-"}</span>
                        </label>
                    </Col>
                    <Col className="px-0">
                        <label className="d-flex"><span>Threshold % :</span>
                            <span className="mx-2">
                                {getThreshold}%
                            </span>
                        </label>
                    </Col>
                </Row>
            </div>
            <CustomModal
                modalOpen={state.modalOpen}
                modalBody={modalBody}
                closeBtn={true}
                closeBtnFuc={handleClose}
                size={'md'}
            />
            {/* <AlertBox
                alert={state.alert}
                type={state.alertType}
                message={state.alertMessage}
            /> */}
        </>
    );
};

export default memo(GoLiveAlertConfigutation);